var rtlStyles = {"rtl":"-qGIb","ltr":"LknpG"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-d2c53744.js.map
